import axios from 'axios'

const apiCliente = axios.create({
	baseURL: process.env.VUE_APP_API_URL || 'http://localhost:9293',
	withCredentials: false,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	}
})

apiCliente.interceptors.request.use(config => {
  const token = sessionStorage.getItem('creccToken')
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})

export default{
  historialAgenda(idPaciente) { return apiCliente.get('/citas/historial', { params: { idPaciente } }) },
  buscarAgenda(params) { return apiCliente.get('/citas/buscar', { params }) },
  reprogramarAgenda(datos) { return apiCliente.post('/citas/reprogramar', datos) },
	verificaUsuario(usr, pss) {
		return apiCliente.post('/usuarios/login', {
			idUsuario: usr,
			contrasena: pss
		})
	},
  buscaDireccion(cp) {
		return apiCliente.post('/codigos/cp',{
			codigoPostal: cp
		})
	},
	catalogosTodos(parametro) {
		return apiCliente.get('/catalogos/todos?tipo='+parametro)
	},
	statusPorTipo(tipoStatus){
		return apiCliente.post('/catalogos/status-por-tipo',{
			idTipo: tipoStatus
		})
	},
	consultaNotas(idCita){
		return apiCliente.post('/notas/consulta',{
			idCita: idCita
		})
	},
	llamadasSeguimiento(){
		return apiCliente.get('/seguimiento/consulta')
	},
	llamadasAsignacion(){
		return apiCliente.get('/asignacion/consulta')
	},
	nuevaSolicitud(paciente) {
		return apiCliente.post('/solicitudes/nueva',{
			nombre: paciente.nombre,
			primerApellido: paciente.primerApellido,
			segundoApellido: paciente.segundoApellido,
			calleyNumero: paciente.calleyNumero,
			idSexo: paciente.idSexo,
			idPoblacion: paciente.idPoblacion,
			fechaNacimiento: paciente.fechaNacimiento,
			telefono1: paciente.telefono1,
			telefono2: paciente.telefono2,
			telefono3: paciente.telefono3,
			idCodigoPostal: paciente.idCodigoPostal,
			idColonia: paciente.idColonia,
			idMunicipio: paciente.idMunicipio,
			idEntidad: paciente.idEntidad,
			edad: paciente.edad
		})
	},
	actualizaSolicitud(solicitud) {
		return apiCliente.post('/solicitudes/actualiza', {
			idSolicitud: solicitud.idSolicitud,
			idModuloPrograma: solicitud.idModuloPrograma,
			narracionHechos: solicitud.narracionHechos,
			observaciones: solicitud.observaciones,
			//contactoRealizado: solicitud.contactoRealizado,
			//asistioPrimerSesion: solicitud.asistioPrimerSesion,
			anotaciones: solicitud.anotaciones,
			//idTerapeuta: solicitud.idTerapeuta,
			idStatusIntervencion: solicitud.idStatusIntervencion,
			idMotivoConsulta: solicitud.idMotivoConsulta,
			seguimiento: solicitud.seguimiento,
		})
	},
	pacientesPendientes() {
		return apiCliente.get('/solicitudes/pendientes')
	},
	nuevaLlamadaSeguimiento(datos) {
		return apiCliente.post('/seguimiento/nuevo',{
			notas: datos.notas,
			observaciones: datos.observaciones,
			idSolicitud: datos.idSolicitud,
			idStatus: datos.idStatus
		})
	},
	nuevaLlamadaAsignacion(datos){
		return apiCliente.post('/asignacion/nuevo',{
			notas: datos.notas,
			observaciones: datos.observaciones,
			idSolicitud: datos.idSolicitud,
			idStatus: datos.idStatus
		})
	},
	agendaCitas(datosParaCita) {
		return apiCliente.post('/citas/alta', {
			idSolicitud: datosParaCita.idSolicitud,
			fechaInicio: datosParaCita.fechaInicio,
			hora: datosParaCita.hora,
			idTerapeuta: datosParaCita.idTerapeuta,
		})
	},
	consultaCitas(datos, tipoEndPoint){
		const endPoint = tipoEndPoint==0 ? '/citas/deSemana' : '/citas/delDia'
		return apiCliente.post(endPoint, {
			idTerapeuta: datos.idTerapeuta,
			fechaActual: datos.fechaActual,
		})
	},
	agregaNotasDeSesion(datos){
		return apiCliente.post('/notas/agrega-notas', {
			idCita: datos.idCita,
			numSesion: datos.numSesion,
			acudio: datos.acudio,
			ultimaSesion: datos.ultimaSesion,
			comentariosDeFalta: datos.comentariosDeFalta,
			horaInicio: datos.horaInicio,
			horaFinalizacion: datos.horaTermino,
			objetivoTerapeutico: datos.objetivoTerapeutico,
			observacionPaciente: datos.observacionPaciente,
			tecnicasTerapeuticas: datos.tecnicasTerapeuticas,
			contenido: datos.contenido,
			tareas: datos.tareas,
			planTerapeutico: datos.planTerapeutico,
			bibliografia: datos.bibliografia,
			resultadosGenerales: datos.resultadosGenerales,
			conclusiones: datos.conclusiones,
			esUltimaSesion: datos.esUltimaSesion,
			statusIntervencion: datos.statusIntervencion,
		})
	},
	buscaNotasDePacientes(datos){
		return apiCliente.post('/notas/busqueda', {
			valorBusqueda: datos,
		})
	},
	buscaNotasDeSesion(idSolicitud){
		return apiCliente.post('/notas/notas_de_sesion', {
			idSolicitud: idSolicitud,
		})
	},
	busquedaNotas(datos){
		return apiCliente.post('/notas/busqueda',{
			tipo: datos.tipo,
			valor: datos.valor,
		})
	},
}
